// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30826":"1ddc7ae2e620b3c9","45481":"2321693c40f27420","68142":"dd0529764ccfba14"}[chunkId] + ".css";
};